import { useMessageToState } from "./useMessageToState";

const getProductOptionCode = (editor: eXpress.core.IEditor) =>
	editor.definition?.selectedProductOptionCode ?? undefined;

export const useSelectedProductOption = () => {
	return useMessageToState({
		name: "useSelectedProductOption",
		filterMessage: eXpress.core.isProductOptionChanged,
		getState: getProductOptionCode,
	});
};
